export default {
  lang: 'English',
  langCode: 'en',
  toolbar: {
    expand: 'Expand Toolbar',
    collapse: 'Collapse Toolbar',
  },
  input: {
    placeholder: 'Enter model URL or drag & drop files below',
  },
  format: {
    auto: 'Auto Detect',
  },
  btn: {
    add: 'Add',
    clearAll: 'Clear All',
    resetView: 'Reset View',
    exportHTML: 'Export as HTML',
    exportGLB: 'Export Model (GLB)',
    exportAnnJSON: 'Export Annotations (JSON)',
    exportZip: 'Export Packaged (ZIP)',
    undo: 'Undo',
    redo: 'Redo',
    split: 'Split',
    restore: 'Restore',
    measure: 'Measure',
    annotate: 'Annotate',
    clear: 'Clear',
    selectSplit: 'Select model to split',
  },
  clip: {
    cut: 'Clip',
    xAxis: 'X Axis',
    yAxis: 'Y Axis',
    zAxis: 'Z Axis',
    section: 'Section',
  },
  status: {
    idle: 'Ready',
    loading: 'Loading model...',
    cleared: 'All cleared',
    loadSuccess: 'Loaded successfully',
    loadFailed: 'Load failed',
    unsupportedFormat: 'Only .stl / .obj / .ply / .gltf / .glb / .fbx / .step / .iges / .brep formats supported',
    loadingFile: 'Loading',
    noSplitParts: 'Model has no separable parts',
    splitDone: 'Split into {count} parts',
    exporting: 'Exporting...',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    annotationHint: 'Annotation added, double-click text to edit',
    noOriginalFile: 'Original file not available, only works for locally imported files',
  },
  model: {
    vertices: 'vertices',
    faces: 'faces',
    part: 'Part',
  },
  material: {
    steel: 'Steel',
    stainless: 'Stainless Steel',
    aluminum: 'Aluminum',
    titanium: 'Titanium',
    copper: 'Copper',
    brass: 'Brass',
    cast_iron: 'Cast Iron',
    zinc: 'Zinc',
    nylon: 'Nylon',
    abs: 'ABS',
    pla: 'PLA',
    pom: 'POM (Delrin)',
    acrylic: 'Acrylic',
    pc: 'Polycarbonate',
    oak: 'Oak',
    pine: 'Pine',
    glass: 'Glass',
    ceramic: 'Ceramic',
  },
  weight: {
    hollow: 'Hollow',
    solid: 'Solid',
    thickness: 'Thick',
    mm: 'mm',
  },
  viewer: {
    leftView: 'Left View',
    rightView: 'Right View',
  },
  loading: {
    modelLoading: 'Loading model...',
    loadingPercent: 'Loading {percent}%',
  },
  dropHint: {
    text: 'Release to load model file (.stl / .obj / .ply / .gltf / .glb / .fbx / .step / .iges / .brep)',
  },
  title: '3D Viewer',
}
